import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative overflow-hidden bg-brand-dark text-white" data-id="element-53" data-mp="2hvm4m8t8rmbp">
      <img src="https://cdn.magicpatterns.com/uploads/pD57FRbuGivB9TRKeXhuqy/Used-IMG_0727.jpg" alt="Inside the Lancer Service shop — vehicles up on rotary lifts in the service bays" className="absolute inset-0 h-full w-full object-cover object-center" data-id="element-54" data-mp="23vtg8k56ti6w" />
      <div className="absolute inset-0 bg-gradient-to-r from-brand-dark from-25% via-brand-dark/85 via-55% to-brand-dark/10" aria-hidden="true" data-id="element-55" data-mp="30l2h7ui7b58h" />
      <div className="absolute inset-0 bg-gradient-to-t from-brand-dark/70 via-transparent to-brand-dark/30" aria-hidden="true" data-id="element-56" data-mp="2mrtay2pjuzu6" />

      <div className="relative z-10 mx-auto max-w-6xl px-5 py-[60px] md:py-28 lg:py-36 pt-[140px] pb-[100px]" data-id="element-57" data-mp="3fhjs6kmhahui">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-2xl space-y-[15px]" data-id="element-58" data-mp="3ka36jjszph0d">
          <span className="mb-4 block text-[14px] font-bold uppercase tracking-widest text-brand-accent" data-id="element-59" data-mp="2p6d75ngvhhnm">
            LANCER SERVICE · ST. PAUL, MN
          </span>
          <h1 className="mb-6 font-heading text-4xl font-extrabold uppercase leading-tight tracking-wide text-balance md:text-5xl lg:text-6xl" data-id="element-60" data-mp="2z39bdgzqnhmd">
            THE CARS THAT LAST AREN'T LUCKY. THEY'RE MAINTAINED.
          </h1>

          <div className="mb-8 text-lg text-gray-200 md:text-xl" data-id="element-61" data-mp="3834pnuolbsqm">
            <p className="mb-8 pr-0 text-xl font-bold text-[#F5F5F4] md:pr-12 pt-[5px]" data-id="element-62" data-mp="3353515binld1">
              A real maintenance program isn't just oil changes. It's brake
              fluid flushes, transmission drain and refills, cooling system
              flushes, cabin and engine air filters, spark plugs, carbon removal
              — done on a schedule built around your vehicle. Lancer helps you
              stay on schedule and tells you honestly what's due, what can wait,
              and what's heading toward a costly repair if it gets ignored.
            </p>

            <div className="mb-5 flex flex-col gap-4 sm:flex-row" data-id="element-63" data-mp="3itlp3ghwlm59">
              <a href="https://www.lancerservice.com/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center rounded-md bg-brand-accent px-8 py-4 font-bold text-white shadow-lg shadow-brand-accent/20 transition-colors hover:bg-brand-accentHover" data-id="element-64" data-mp="3mtvqefur3ods">
                Schedule a Maintenance Inspection →
              </a>
              <a href="tel:6512240267" className="inline-flex items-center justify-center gap-2 rounded-md border-2 border-gray-500 bg-brand-dark/50 px-8 py-4 font-bold text-white backdrop-blur-sm transition-colors hover:border-gray-300" data-id="element-65" data-mp="adiep2zepjd8">
                <PhoneIcon className="h-5 w-5" data-id="element-66" data-mp="23vpoh2quqicm" />
                Call (651) 224-0267
              </a>
            </div>

            <p className="mb-8 text-sm font-medium text-gray-300" data-id="element-67" data-mp="1yxo5sixc8l1o">
              Photos & video included · After-hours drop-off available
            </p>
          </div>

          <blockquote className="mb-8 border-l-4 border-brand-accent pl-5 text-base italic leading-relaxed text-gray-100 md:text-lg" data-id="element-68" data-mp="1pwhpa9uova8f">
            “They pulled my Carfax report to verify what mileage-based
            maintenance was actually due. There were absolutely no high-pressure
            sales or unnecessary upsells — they only recommended what made
            sense.” — James K., Google Review ★★★★★
          </blockquote>

          <div className="text-sm font-medium" data-id="element-69" data-mp="368wunv77zgxt">
            <p className="pt-2 text-white" data-id="element-70" data-mp="369ol6rlymoh8">
              <span className="text-base tracking-wider text-brand-accent" data-id="element-71" data-mp="31i6oifqyza22">
                ★★★★★
              </span>{' '}
              <span className="text-base font-bold" data-id="element-72" data-mp="2l25te11txs5r">4.9</span>{' '}
              <span className="ml-2 text-base text-gray-300" data-id="element-73" data-mp="2l50fdx0hrl1a">
                · Trusted in St. Paul since 1977
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}